import { WalletLinksMixin } from "src/types";
import googleWalletImgUrl from "/src/assets/enAU_add_to_google_wallet_add-wallet-badge.svg";

type WalletLinksProps = WalletLinksMixin;

export const WalletLinks = (props: WalletLinksProps) => {
  return (
    <div>
      {props.google_wallet_link && (
        <a
          href={props.google_wallet_link}
          target="_blank"
          style={{ margin: "10px", display: "inline-block" }}
        >
          <img src={googleWalletImgUrl} />
        </a>
      )}
    </div>
  );
};
